import { useTranslation } from "react-i18next";

const PracticeRestoredDescription = () => {
    const { t } = useTranslation();

    return <>{t("historical-actions-practice-restored-description")}</>;
};

export default PracticeRestoredDescription;
